<template>
  <div class="charts" v-loading="loader">
    <Chart
      v-if="datacollection.labels.length > 0"
      :style="myStyles"
      :chart-data="datacollection">
    </Chart>
    <div v-else>
      <p class="no-data">No data</p>
    </div>
  </div>
</template>

<script>
  import Chart from './Chart';
  import TxProxy from '../../../proxies/TxProxy';
  import moment from 'moment';

  export default {
    name: 'ChartContainer',
    components: { Chart },
    props: ['totalSupply'],
    computed: {
      myStyles() {
        return {
          height: '220px',
          marginTop: '20px',
          width: '100%',
          position: 'relative',
        };
      }
    },
    methods: {
      getRandomInt() {
        return Math.floor(Math.random() * (20 - 19 + 1)) + 5;
      }
    },
    async mounted() {
      try {

        const tx_proxy = new TxProxy();

        const charts = await tx_proxy.charts(this.$route.params.id);
        const init_supply = this.totalSupply - charts.total

        charts.charts.data.unshift(init_supply);
        charts.charts.labels.unshift('');
        let total = 0;
        this.datacollection.datasets[0].data = charts.charts.data.map((d) => {
          total = d + total;
          return total;
        });
        this.datacollection.labels = charts.charts.labels.map((label) => {
          if(label.length < 4) return '';
          return moment(label).format('ll')
        });
        // this.datacollection.labels = charts.charts.labels;
        console.log(  this.datacollection.labels, "LABELS")


        if (this.datacollection.datasets[0].data.length < 2) {
          this.datacollection.labels.push('')
          this.datacollection.datasets[0].data.push(init_supply)

        }
        this.loader = false;
      } catch (e) {
        console.error(e)
      }
    },
    data: function () {
      return {
        time: '1d',
        loader: true,
        datacollection: {
          labels: [],
          datasets: [
            {
              label: 'Supply',
              backgroundColor: 'rgba(64,158,255, 0)',
              data: [],
              borderColor: [
                '#d2f400',
              ],
              borderWidth: 2.4
            }
          ]
        }
      };
    }
  };
</script>

<style scoped>
  .charts {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .text-grey {
    margin-bottom: 20px;
  }

  .no-data {
    margin-top: 150px;
    color: #ccc;
  }
</style>
